import { render } from "./ShaxsiyIshRejaDetail.vue?vue&type=template&id=025dca4e&scoped=true"
import script from "./ShaxsiyIshRejaDetail.vue?vue&type=script&lang=js"
export * from "./ShaxsiyIshRejaDetail.vue?vue&type=script&lang=js"

import "./ShaxsiyIshRejaDetail.vue?vue&type=style&index=0&id=025dca4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025dca4e"]])

export default __exports__